export default __webpack_public_path__ + "img/fvolsQFU.17ffa786.svg";